import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PageLayout from '../../Pages/PageLayout'
import HomePage from '../../Pages/Home';
import EssencePage from '../../Pages/Essence';
import StructurePage from '../../Pages/Structure';
import AccessoriesPage from '../../Pages/Accessories';
import FinalizationPage from '../../Pages/Finalization';
import TerracePage from '../../Pages/Terrace';
import FixturePage from '../../Pages/Fixture';
import StructureInstallationPage from '../../Pages/StructureInstallation';
import NotFound from '../../Pages/NotFound/NotFound';
import Project from '../../Pages/Projet';
import NestedSection from '../../Pages/NestedSection';

const Routers = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route element = {<PageLayout />} >
            <Route path = '/' element={<HomePage />} />
            <Route  path= "/essence" element={<EssencePage />} />
            <Route  path= "/projet/:projectId" element={<Project />} />
            <Route  path= "/projet/:projectId/nested/:nestedSectionId" element={<NestedSection />} />
            {/* <Route path ='/structure' element={<CreateProcess />} /> */}
            <Route path='/structure' element={<StructurePage />} />
            <Route path='/structureinstall' element={<StructureInstallationPage />} />
            <Route path='fixture' element={<FixturePage />} />
            <Route path='accessories' element={<AccessoriesPage />} />
            <Route path='finalization' element={<FinalizationPage />} />
            <Route path='terrace' element={<TerracePage />} />
          </Route>
          <Route path="*" element={<NotFound/>}/>
        </Routes>
      </Router>
      
    </>
  )
};

export default Routers;